import React from 'react';
import {CGE} from "../../CGE";
import classNames from 'classnames';

function Card(props) {

  props.disabled ? props.onClick = null : props.onClick = props.onClick;
  
  return (
    <div 
      className={classNames(
        'cge-card', props.className,
        {
        'cge-card-disabled' : props.disabled,
        }
      )}
      onClick={props.onClick}
      id={props.id}
      readOnly
    >
        
        {props.description ? 
          <> 
            <CGE.Text text={props.label} size="3" className="card-label-color" /> 
            <CGE.Text text={props.description} size="2" className="card-description-color" /> 
          </>
        : 
          <>
            <CGE.Text text={props.label} size="3" className="card-label-color" /> <br></br>
          </>
        }
        <div className="dinamic-info">
          <CGE.Text text={props.dataInfoShow} size="2" className="card-dinamic-info-color" />
        </div>
    </div>
  )
}

export default Card;
